import { LearningObject, Course, EnrollmentStateTypes } from '../';
import type { ILearningObjectData } from '../';
import type { ICertification } from '.';

export class Certification extends LearningObject implements ICertification {
  courses: Course[] = [];
  constructor(data: ILearningObjectData) {
    super(data);
    if (data?.courses) {
      this.courses = data.courses.map((c) => new Course(c));
    }
  }
  validate(): void {
    throw new Error('Method not implemented.');
  }

  get inactiveCourses(): Course[] {
    return this.courses.filter((course) => !course.activeInstance);
  }

  get isActive(): boolean {
    if (this.enrollment && !!this.activeInstance && !this.isDeadlinePassed && !this.inactiveCourses.length) return true;
    return false;
  }

  get activeCourseId(): string | undefined {
    return this.courses.find((c) => !c.hasPassed)?.id || this.courses[0]?.id;
  }

  get isUploadable(): boolean {
    return !!(
      this.enrollment &&
      ![EnrollmentStateTypes.Pending, EnrollmentStateTypes.Approved, EnrollmentStateTypes.Completed].includes(
        this.enrollment.state
      ) &&
      this.isExternal
    );
  }
}
